import { render, staticRenderFns } from "./report-dki-r.vue?vue&type=template&id=5b1b81d0&scoped=true&"
import script from "./report-dki-r.vue?vue&type=script&lang=ts&"
export * from "./report-dki-r.vue?vue&type=script&lang=ts&"
import style0 from "./report-dki-r.vue?vue&type=style&index=0&id=5b1b81d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b81d0",
  null
  
)

export default component.exports